import React, { useState, useEffect, useCallback, useRef } from 'react';
import { brandTextLogo } from '../../utils/brandLogos';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import Loading from 'react-loading';
import cep from 'cep-promise'
import { createEmpresaUser, getEstados, getMunicipios, importCardapioAnotaai, importCardapioIfood } from '../../services/api';

import { trackEvent } from '../../utils/facebookPixel';
import { Slide } from 'react-toastify';
import { useTranslation } from 'react-i18next';

// Hook para detectar mobile
function useIsMobile() {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);
    React.useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return isMobile;
}

const Endereco = () => {
    const { t } = useTranslation('auth');
    const location = useLocation();
    const { infoEmpresaObj, passwordObj, linkObj } = location.state || {};
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(infoEmpresaObj);//

    const navigate = useNavigate();
    const [optSelected, setOptSelected] = useState('endereco');
    const [expandEndereco, setExpandEndereco] = useState(false);
    const [isSearching, setIsSearching] = useState(false);

    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState('');

    const [localCepValue, setLocalCepValue] = useState(''); // Estado local para o InputMask
    const [estado, setEstado] = useState("");
    const [municipio, setMunicipio] = useState('');
    const [loading, setLoading] = useState(false); // Estado para bloquear o botão

    const isMobile = useIsMobile();
    const debounceTimeoutRef = useRef(null);
    const lastCepValueRef = useRef('');

    useEffect(() => {
        (async () => {
            const response = await getEstados();
            setUfs(response.data);
        })();

        if (window.fbq) {
            trackEvent('CadastroEndereco', {
                step: 'endereco'
            });
        }

    }, []);

    useEffect(() => {
        getMunicipios(estado).then((response) => {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("MUNICIPIOS:::",response);
            setCities(response.data);
        })
    }, [estado]);

    const handleOptSelected = (opt) => {
        setOptSelected(opt);

        if (opt === "info") {
            navigate("/informacoes", { state: { infoEmpresaObj, passwordObj, linkObj } });
        }
        if (opt === "credential") {
            navigate("/credenciais", { state: { infoEmpresaObj, passwordObj, linkObj } });
        }
        if (opt === "import") {
            navigate("/integracao", { state: { infoEmpresaObj, passwordObj, linkObj } });
        }
    }

    //Validações
    const SignUpSchema = Yup.object().shape({
        cep: Yup.string().matches(/^\d{5}-\d{3}$/, t('register.address.validation.invalidCep')).required(t('register.validation.fieldRequired')),
        estado: Yup.string().required(t('register.validation.fieldRequired')),
        municipio: Yup.string().required(t('register.validation.fieldRequired')),
        bairro: Yup.string().required(t('register.validation.fieldRequired')),
        logradouro: Yup.string().required(t('register.validation.fieldRequired')),
        numero: Yup.string().required(t('register.validation.fieldRequired')),
        complemento: Yup.string(),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        //enableReinitialize: true,
        initialValues: {
            cep: "",
            estado: "",
            municipio: "",
            bairro: "",
            logradouro: "",
            numero: "",
            complemento: "",
            //password: passwordObj?passwordObj.password:"",
            //confirmPassword: passwordObj?passwordObj.confirmPassword:"",
        },
        onSubmit: (values) => {

            const cep = values.cep;
            const estado = values.estado;
            const municipio = values.municipio;
            const bairro = values.bairro;
            const logradouro = values.logradouro;
            const numero = values.numero;
            const complemento = values.complemento;

            //navigate("/integracao", {state: {infoEmpresaObj, passwordObj}});

            handleSubmitAPI(cep, estado, municipio, bairro, logradouro, numero, complemento);

        },
    });

    /*const importaCardapioIfood = async (ifoodLinkToSend) => {
        const response = await importCardapioIfood(ifoodLinkToSend);
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response);
        toast('Importação realizada com sucesso!', {autoClose:5000, type: 'success'});
    };*/

    /*
    const importaCardapioAnotaai = async (anotaAiLinkToSend) => {
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("anotaAiLinkToSend>",anotaAiLinkToSend.toString())
        const response = await importCardapioAnotaai(anotaAiLinkToSend);
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response);
        toast('Importação realizada com sucesso!', {autoClose:5000, type: 'success'});
    };*/

    const handleSubmitAPI = async (cep, estado, municipio, bairro, logradouro, numero, complemento) => {
        if (loading) return; // Evita chamadas duplicadas

        setLoading(true); // Desativa o botão

        try {
            const nome_empresa = infoEmpresaObj.establishmentName;
            const cpf_cnpj = infoEmpresaObj.cpf_cnpj;
            const hasComputer = infoEmpresaObj.hasComputer;
            const email = infoEmpresaObj.email;
            const telefone = infoEmpresaObj.phone;
            const nome_pessoa = infoEmpresaObj.personName;
            const password = passwordObj.password;
            const confirmPassword = passwordObj.confirmPassword;

            const type = "Empresa";
            const vinculo = cpf_cnpj;

            // Registrando a empresa
            const response = await createEmpresaUser(
                cpf_cnpj, nome_empresa, email, cep, estado, municipio,
                bairro, logradouro, numero, complemento, telefone, type,
                hasComputer, nome_pessoa, password, confirmPassword, vinculo
            );

            if (response.status === 201) {
                toast(response.data.msg, { autoClose: 5000, type: "success" });

                // Disparando evento do Meta Pixel após cadastro bem-sucedido
                if (window.fbq) {

                    // Evento de conversão
                    trackEvent('CadastroCompleto', {
                        user_type: 'empresa',
                        has_computer: hasComputer,
                        integration: linkObj ? linkObj.importType : null
                    });

                }

                if (linkObj) {
                    if (linkObj.importType === 'linkIfood') {
                        importCardapioIfood(linkObj.importLink, response.data.seqIdEmpresa);
                    } else if (linkObj.importType === 'linkAnotaAi') {
                        importCardapioAnotaai(linkObj.importLink, response.data.seqIdEmpresa);
                    }
                }
                navigate("/");
            } else {
                toast.error(<span>{response.data.msg} <span style={{textDecoration:'underline', color:'#007bff', cursor:'pointer'}} onClick={() => navigate('/informacoes', { state: { infoEmpresaObj, passwordObj, linkObj } })}>{t('register.address.backToStart')}</span></span>, { autoClose: 8000, transition: Slide });
            }
        } catch (err) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro na API:', err);

            // Capturando apenas a mensagem de erro
            const msg = err.response?.data?.msg || t('register.address.unknownError');

            toast.error(<span>{t('register.address.errorPrefix')}: {msg} <span style={{textDecoration:'underline', color:'#007bff', cursor:'pointer'}} onClick={() => navigate('/informacoes', { state: { infoEmpresaObj, passwordObj, linkObj } })}>{t('register.address.backToStart')}</span></span>, { autoClose: 8000, transition: Slide });
        } finally {
            setLoading(false); // Reativa o botão ao final da requisição
        }
    };

    // Função para formatar CEP (99999-999)
    const formatCep = (value) => {
        // Remove tudo que não é número
        const numbers = value.replace(/\D/g, '');
        
        // Limita a 8 dígitos
        const limitedNumbers = numbers.slice(0, 8);
        
        // Aplica a máscara
        if (limitedNumbers.length <= 5) {
            return limitedNumbers;
        } else {
            return `${limitedNumbers.slice(0, 5)}-${limitedNumbers.slice(5)}`;
        }
    };

    // Função para buscar CEP - definida antes para evitar hoisting issues
    const handleSearchCep = useCallback((cepToSearch) => {
        setIsSearching(true);
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("cepToSearch",cepToSearch.length)
        if (cepToSearch.length === 9) {
            cep(cepToSearch).then(response => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response)      
                //idEstado.value = response.state
                //setEstado(idEstado.value)
                setEstado(response.state)
                formik.setFieldValue('estado', response.state)
                setMunicipio(response.city)
                formik.setFieldValue('municipio', response.city)
                //setBairro(response.neighborhood)
                formik.setFieldValue('bairro', response.neighborhood)
                //setLogradouro(response.street)
                formik.setFieldValue('logradouro', response.street)
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(estado);
            }).catch(error => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(error);
            }).finally(() => {
                setIsSearching(false);
                setExpandEndereco(true);
                // Preenche o número com 's/n' se estiver vazio
                if (!formik.values.numero) {
                    setTimeout(() => {
                        formik.setFieldValue('numero', 's/n');
                    }, 0);
                }
            });

        }
    }, [formik, setIsSearching, setEstado, setMunicipio, setExpandEndereco]);

    // Função debounced para buscar CEP
    const debouncedSearchCep = useCallback((cepValue) => {
        // Limpa timeout anterior se existir
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        
        // Define novo timeout
        debounceTimeoutRef.current = setTimeout(() => {
            if (cepValue && cepValue.length === 9) {
                handleSearchCep(cepValue);
            }
        }, 300); // 300ms de debounce
    }, [handleSearchCep]);

    // Handler simplificado para mudanças no CEP
    const handleCepChange = useCallback((e) => {
        const rawValue = e.target.value;
        const formattedValue = formatCep(rawValue);
        
        // Evita processamento de valores idênticos
        if (lastCepValueRef.current === formattedValue) {
            return;
        }
        
        lastCepValueRef.current = formattedValue;
        
        // Atualiza estados
        setLocalCepValue(formattedValue);
        formik.setFieldValue('cep', formattedValue);
        //setCepNumber(formattedValue);
        
        // Verifica se deve buscar o CEP (8 dígitos = 9 caracteres com hífen)
        const numbers = formattedValue.replace(/\D/g, '');
        if (numbers.length === 8) {
            debouncedSearchCep(formattedValue);
        }
    }, [debouncedSearchCep, formik]);

    // Cleanup do timeout quando o componente for desmontado
    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    return (
        <div className='containerAddEmpresa'>
            <div className='divSidePanel'>
                <div className='divSidePanelContent'>
                    <div className='divLogo'>
                        <img width={140} height={42} src={brandTextLogo} alt='Logo' />
                    </div>
                    <div className='divMenu'>
                        <div className='divMenuItem'>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "info" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "info" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("info")}>{t('register.sidebarStep1')}</p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "credential" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "credential" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("credential")}>{t('register.sidebarStep2')}</p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "import" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "import" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("import")}>{t('register.address.sidebarStep3')}</p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {optSelected === "endereco" ? <div className='menuItemSelected' /> : null}
                                <p className={optSelected === "endereco" ? 'btnOptionsAddEmpresa checked' : "btnOptionsAddEmpresa"} onClick={() => handleOptSelected("endereco")}>{t('register.address.sidebarStep4')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="containerAddEmpresaForm">
                {loading ?
                    <div className='waitingFinishFormEmpresa'>
                        <span>{t('register.address.waitingFinish')}</span>
                        <Loading type='spin' fill='black' style={{ color: 'black', width: '50px' }} />
                    </div>
                    : null
                }
                <form onSubmit={formik.handleSubmit} className="formAddEmpresa">

                    <div className='informationsAccount'>

                        <div style={{
                            ...styles.container,
                            maxWidth: isMobile ? '100%' : styles.container.maxWidth,
                            padding: isMobile ? '10px' : styles.container.padding,
                        }}>
                            <h1 style={styles.header}>{t('register.address.title')}</h1>
                            <p style={styles.description}>
                                {t('register.address.description')} <span style={{ fontWeight: '900', fontSize: 15, textDecoration: 'underline' }}>Delivery</span>
                            </p>
                            <div style={styles.inputGroup}>
                                <label style={styles.label} htmlFor="cep">{t('register.address.cepLabel')} *</label>
                                <input
                                    style={styles.input}
                                    type="text"
                                    id="cep"
                                    name="cep"
                                    placeholder="00000-000"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    spellCheck={false}
                                    inputMode="numeric"
                                    onChange={handleCepChange}
                                    value={localCepValue}
                                    maxLength="9"
                                />
                                {formik.errors.cep && (
                                    <div className="error">{formik.errors.cep}</div>
                                )}
                            </div>

                            {isSearching &&
                                <Loading style={{ fill: 'gray', height: '32px', width: '32px' }} />
                            }

                            {expandEndereco &&
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : undefined }}>
                                        <div style={styles.inputGroup}>
                                            <label style={styles.label} htmlFor="cep">{t('register.address.stateLabel')} *</label>
                                            {/*<!-- Custom select structure --> */}
                                            <div
                                                className="selectdiv estadoPersonalized"
                                                style={{
                                                    width: isMobile ? '100%' : '260px',
                                                    minWidth: 0,
                                                    maxWidth: '100%',
                                                }}
                                            >
                                                <label style={{ width: "100%" }}>
                                                    <select
                                                        id="estado"
                                                        type="text"
                                                        name="estado"
                                                        onChange={(e) => {
                                                            setEstado(e.currentTarget.value)
                                                            formik.setFieldValue('estado', e.currentTarget.value);
                                                        }}
                                                        value={formik.values.estado}
                                                        className={estado === "" ? 'invalid-option' : 'beleza'}
                                                        style={{
                                                            width: "100%", color: "black", fontWeight: "400", fontSize: "16px",
                                                            border: "1px solid rgb(204, 204, 204)", borderRadius: "4px", boxShadow: 'none', padding: "0px 24px 0px 10px"
                                                        }}
                                                    >
                                                        <option value="" /*className="invalid-option"*/>{t('register.address.selectState')}</option>
                                                        {ufs.map((uf) => (
                                                            <option key={uf.id} value={uf.sigla} style={{ color: "black" }}>
                                                                {uf.nome}
                                                            </option>
                                                        ))}

                                                    </select>
                                                </label>
                                            </div>
                                            {formik.errors.estado && (
                                                <div className="error">{formik.errors.estado}</div>
                                            )}
                                        </div>

                                        <div style={styles.inputGroup}>
                                            <label style={styles.label} htmlFor="cep">{t('register.address.cityLabel')} *</label>
                                            {/*<!-- Custom select structure --> */}
                                            <div className="selectdiv" style={{ width: isMobile ? '100%' : '260px' }}>
                                                <label style={{ width: "100%" }}>
                                                    <select
                                                        id="municipio"
                                                        type="text"
                                                        name="municipio"
                                                        onChange={(e) => {
                                                            setMunicipio(e.currentTarget.value)
                                                            formik.setFieldValue('municipio', e.currentTarget.value);
                                                        }}
                                                        value={formik.values.municipio}
                                                        className={municipio === "" ? 'invalid-option' : 'beleza'}
                                                        style={{
                                                            width: "100%", color: "black", fontWeight: "400", fontSize: "16px",
                                                            border: "1px solid rgb(204, 204, 204)", borderRadius: "4px", boxShadow: 'none', padding: "0px 24px 0px 10px"
                                                        }}
                                                    >
                                                        <option value="" /*className="invalid-option"*/>{t('register.address.selectCity')}</option>
                                                        {cities && cities.map((city) => (
                                                            <option key={city.id} value={city.nome} style={{ color: "black" }}>
                                                                {city.nome}
                                                            </option>
                                                        ))}

                                                    </select>
                                                </label>
                                            </div>
                                            {formik.errors.municipio && (
                                                <div className="error">{formik.errors.municipio}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : undefined }}>
                                        <div style={styles.inputGroup} className='divBairro'>
                                            <label style={styles.label} htmlFor="bairro">{t('register.address.neighborhoodLabel')} *</label>
                                            <input style={styles.input} type="text"
                                                id="bairro"
                                                name="bairro"
                                                placeholder={t('register.address.neighborhoodPlaceholder')}
                                                onChange={(e) => {
                                                    //setBairro(e.currentTarget.value)
                                                    formik.setFieldValue('bairro', e.currentTarget.value);
                                                }}
                                                value={formik.values.bairro} />
                                            {formik.errors.bairro && (
                                                <div className="error">{formik.errors.bairro}</div>
                                            )}
                                        </div>

                                        <div style={styles.inputGroup} className='divLogradouro'>
                                            <label style={styles.label} htmlFor="logradouro">{t('register.address.streetLabel')} *</label>
                                            <input style={styles.input} type="text"
                                                id="logradouro"
                                                name="logradouro"
                                                placeholder={t('register.address.streetPlaceholder')}
                                                onChange={(e) => {
                                                    //setLogradouro(e.currentTarget.value)
                                                    formik.setFieldValue('logradouro', e.currentTarget.value);
                                                }}
                                                value={formik.values.logradouro} />
                                            {formik.errors.logradouro && (
                                                <div className="error">{formik.errors.logradouro}</div>
                                            )}
                                        </div> 
                                    </div>

                                    <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : undefined }}>
                                        <div style={styles.inputGroup} className='divNumero'>
                                            <label style={styles.label} htmlFor="numero">{t('register.address.numberLabel')} *</label>
                                            <input style={styles.input} type="text"
                                                id="numero"
                                                name="numero"
                                                placeholder="Ex: 12A"
                                                onChange={(e) => {
                                                    //setBairro(e.currentTarget.value)
                                                    formik.setFieldValue('numero', e.currentTarget.value);
                                                }}
                                                value={formik.values.numero} />
                                            {formik.errors.numero && (
                                                <div className="error">{formik.errors.numero}</div>
                                            )}
                                        </div>

                                        <div style={styles.inputGroup} className='divComplemento'>
                                            <label style={styles.label} htmlFor="complemento">{window.innerWidth > 600 ? t('register.address.complementLabelFull') : t('register.address.complementLabel')}</label>
                                            <input style={styles.input} type="text"
                                                id="complemento"
                                                name="complemento"
                                                placeholder={t('register.address.complementPlaceholder')}
                                                onChange={(e) => {
                                                    //setLogradouro(e.currentTarget.value)
                                                    formik.setFieldValue('complemento', e.currentTarget.value);
                                                }}
                                                value={formik.values.complemento} />
                                            {formik.errors.complemento && (
                                                <div className="error">{formik.errors.complemento}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{
                                        ...styles.buttonGroup,
                                        flexDirection: isMobile ? 'column' : 'row',
                                        gap: isMobile ? '10px' : styles.buttonGroup.gap,
                                    }}>
                                        <button
                                            type="submit"
                                            style={{
                                                ...styles.button,
                                                width: isMobile ? '100%' : 'auto',
                                            }}
                                            className='btnFwdCadastros'
                                            disabled={loading} // 🔹 Desativa o botão durante a requisição
                                        >
                                            {loading ? t('register.address.finishing') : t('register.address.finishRegistration')}
                                        </button>
                                    </div>
                                </>
                            }

                        </div>

                    </div>

                </form>
            </div>



        </div>
    );
}


const styles = {
    container: {
        width: '100%',
        maxWidth: '600px',
        margin: '0 auto',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        boxSizing: 'border-box',
        overflowX: 'hidden',
    },
    header: {
        fontSize: '24px',
        marginBottom: '10px',
    },
    description: {
        fontSize: '16px',
        marginBottom: '20px',
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    button: {
        padding: '10px 20px',
        fontSize: '16px',
        borderRadius: '4px',
        cursor: 'pointer',
    }
};


export default Endereco;

